import type { I18n, MessageDescriptor } from '@lingui/core';
import { useLingui } from '@lingui/react';

export type LocalizedMessage = string | MessageDescriptor;

export function resolveMessage(
    i18n: I18n,
    value: LocalizedMessage,
    values?: Record<string, unknown>,
): string {
    if (typeof value === 'string') {
        return value;
    }
    return values ? i18n._({ ...value, values }) : i18n._(value);
}

export function useResolvedMessage(value: LocalizedMessage): string {
    const { i18n } = useLingui();
    return resolveMessage(i18n, value);
}

export function useOptionalResolvedMessage(
    value: LocalizedMessage | null | undefined
): string | null {
    const { i18n } = useLingui();
    if (value === null || value === undefined) {
        return null;
    }
    return resolveMessage(i18n, value);
}
